export default "__VITE_ASSET__B$io8yE1__"